import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useMemo } from "react";

import { applyFilters } from "../slices/filterSlice";
import { setTempFilter } from "../slices/filterSlice";
import { clearFilters } from "../slices/filterSlice";
import { setSearch } from "../slices/filterSlice";
import { setTempSearch } from "../slices/filterSlice";

export const useApplyFilters = ({ componentId }) => {
    const dispatch = useDispatch();

    const tempFilters = useSelector(state =>
        state.filters.filters[componentId]?.tempFilters || {}
    );

    const appliedFilters = useSelector(state =>
        state.filters.filters[componentId]?.appliedFilters || {}
    );

    const tempSearch = useSelector(state =>
        state.filters.filters[componentId]?.tempSearch || ""
    );

    const search = useSelector(state =>
        state.filters.filters[componentId]?.search || ""
    );

    const page = useSelector(state => state.filters.page);

    const params = useMemo(() => {
        const params = [];

        Object.entries(appliedFilters).forEach(([key, value]) => {
            if (!key || value == null || (Array.isArray(value) && value.length === 0)) return;

            if (typeof value === "object" && 'from' in value && 'to' in value) {
                const from = value.from?.slice(0, 10);
                const to = value.to?.slice(0, 10);
                params.push(`${key}=${from}|${to}`);
                return;
            }

            if (Array.isArray(value)) {
                value.forEach(val => {
                    params.push(`${key}[]=${encodeURIComponent(val)}`);
                });
                return;
            }

            params.push(`${key}=${encodeURIComponent(value)}`);
        });

        if (search) {
            params.push(`search=${encodeURIComponent(search)}`);
        }

        params.push(`page=${page}`);

        return params.join("&");
    }, [appliedFilters, page, search]);

    const handleChange = (filterKey, newValue) => {
        dispatch(setTempFilter({ componentId, key: filterKey, value: newValue }));
    };

    const applyFiltersParams = () => {
        dispatch(applyFilters({ componentId }));
    };

    const setTempSearchValue = (value) => {
        dispatch(setTempSearch({ componentId, value }));
    };

    const setSearchValue = (value) => {
        dispatch(setSearch({ componentId, value }));
    };

    const clearFiltersParams = () => {
        dispatch(clearFilters({ componentId }));
    };

    return {
        value: tempFilters,
        handleChange,
        applyFiltersParams,
        clearFiltersParams,
        setTempSearchValue,
        setSearchValue,
        search,
        tempSearch,
        params
    };
};

